import { useState } from "react";
import api from "../api";
import { Modal } from "./ui";

const byName = (a, b) => (a.name || "").localeCompare(b.name || "", "it");
const pFull = (p) => `${p.last_name || ""} ${p.first_name || ""}`.trim();

// Select unico per collegare a: cliente, lead o persona. value: "" | "c:ID" | "p:ID"
export function ContactSelect({ value, onChange, companies, persons, testid }) {
  const clienti = companies.filter((c) => c.kind !== "lead").sort(byName);
  const leads = companies.filter((c) => c.kind === "lead").sort(byName);
  const pers = [...persons].sort((a, b) => pFull(a).localeCompare(pFull(b), "it"));
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      <option value="">— Nessuno / lavoro interno —</option>
      {clienti.length > 0 && <optgroup label="Clienti">{clienti.map((c) => <option key={c.id} value={`c:${c.id}`}>{c.name}</option>)}</optgroup>}
      {leads.length > 0 && <optgroup label="Lead">{leads.map((c) => <option key={c.id} value={`c:${c.id}`}>{c.name}</option>)}</optgroup>}
      {pers.length > 0 && <optgroup label="Persone / contatti">{pers.map((p) => <option key={p.id} value={`p:${p.id}`}>{pFull(p)}</option>)}</optgroup>}
    </select>
  );
}

export function linkedToBody(value) {
  if (!value) return { company_id: null, person_id: null };
  const [kind, tid] = value.split(":");
  return kind === "c" ? { company_id: tid, person_id: null } : { person_id: tid, company_id: null };
}

// Pulsante "Sposta" per riassegnare un incarico a un altro cliente/lead/persona.
export function TaskMoveButton({ task, onMoved }) {
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState("");
  const [lists, setLists] = useState(null);
  const [busy, setBusy] = useState(false);

  const openModal = async () => {
    if (!lists) {
      try {
        const [rc, rp] = await Promise.all([api.get("/companies?limit=2000"), api.get("/persons")]);
        setLists({ companies: rc.data, persons: rp.data });
      } catch { setLists({ companies: [], persons: [] }); }
    }
    setTarget(task.company_id ? `c:${task.company_id}` : task.person_id ? `p:${task.person_id}` : "");
    setOpen(true);
  };

  const doMove = async () => {
    setBusy(true);
    try {
      await api.put(`/tasks/${task.id}`, linkedToBody(target));
      setOpen(false);
      onMoved && onMoved();
    } catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <button className="btn sm" onClick={openModal} title="Sposta l'incarico su un altro cliente, lead o persona" data-testid={`task-move-${task.id}`}>⇄ Sposta</button>
      {open && (
        <Modal title="Sposta incarico" onClose={() => setOpen(false)}>
          <p className="muted" style={{ marginTop: 0 }}>«{task.title}»</p>
          <div className="field"><label>Collega a</label>
            <ContactSelect value={target} onChange={setTarget} companies={lists?.companies || []} persons={lists?.persons || []} testid="task-move-select" />
          </div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setOpen(false)}>Annulla</button>
            <button className="btn primary" onClick={doMove} disabled={busy} data-testid="task-move-confirm">{busy ? "Spostamento…" : "Sposta"}</button>
          </div>
        </Modal>
      )}
    </>
  );
}
